import * as React from "react"
import { gql } from "@apollo/client"
import { Button, Stack } from "@chakra-ui/react"

import { useForm } from "lib/hooks/useForm"
import { categoryMultiOptions } from "lib/static/filters"
import { Checkbox } from "components/Checkbox"
import { Form } from "components/Form"
import { FormError } from "components/FormError"
import { Input } from "components/Input"

import { ProfilePostFragment, useUpdatePostMutation } from "../lib/graphql"
import yup from "../lib/yup"
import { DateInput } from "./DateInput"
import { MultiSelect } from "./MultiSelect"
import { Textarea } from "./Textarea"

const _ = gql`
  mutation UpdatePost($id: String!, $data: UpdatePostInput!) {
    updatePost(id: $id, data: $data) {
      ...PostItem
    }
  }
`

const EditSchema = yup.object().shape({
  title: yup.string().required("Verplicht"),
  description: yup.string().required("Verplicht"),
  videoUrl: yup.string().url().nullIfEmpty(),
  isClosed: yup.boolean().required("Verplicht"),
  deadline: yup.string().required("Verplicht"),
  categories: yup.array().of(yup.string()).required("Verplicht"),
})

interface Props {
  post: ProfilePostFragment
  closeModal: () => void
  refetchPosts: () => void
}

export default function PostEditForm({ post, closeModal, refetchPosts }: Props) {
  const [updatePost] = useUpdatePostMutation()

  const defaultValues = {
    title: post?.title || "",
    description: post?.description || "",
    isClosed: post?.isClosed || false,
    deadline: post?.deadline || "",
    videoUrl: post?.videoUrl || "",
    categories: [...post.categories] || [],
  }

  const form = useForm({ defaultValues, schema: EditSchema })

  const onSubmit = (values: any) => {
    return form.handler(() => updatePost({ variables: { id: post.id, data: values } }), {
      onSuccess: (_, toast) => {
        refetchPosts()
        form.reset(values)
        toast({ description: "Post bijgewerkt!" })
        closeModal()
      },
    })
  }

  return (
    <Form onSubmit={onSubmit} {...form}>
      <Stack spacing={8}>
        <Input name="title" label="Titel" placeholder="Artist wanted for project" />
        <Textarea name="description" label="Beschrijving" />
        <Input name="videoUrl" label="Video Url" />
        <MultiSelect name="categories" label="Categorieën" options={categoryMultiOptions} />
        <Checkbox name="isClosed" label="Close" />
        <DateInput name="deadline" label="Deadline" isRequired />
        <Button colorScheme="yellow" type="submit" w="100%">
          Save
        </Button>
        <FormError />
      </Stack>
    </Form>
  )
}
